export const BUYER_LIST_RIGHT_MENU = {
  SET_INITIAL_PURCHASE_DATE:'BUYER_LIST_RIGHT_MENU.SET_INITIAL_PURCHASE_DATE',
  SET_INITIAL_STATUS:'BUYER_LIST_RIGHT_MENU.SET_INITIAL_STATUS',
  SET_INITIAL_ORDER:'BUYER_LIST_RIGHT_MENU.SET_INITIAL_ORDER',
  SET_INITIAL_STATE_MENU:'BUYER_LIST_RIGHT_MENU.SET_INITIAL_STATE_MENU',
  SET_INITIAL_SHOW_DETAILS:'BUYER_LIST_RIGHT_MENU.SET_INITIAL_SHOW_DETAILS',
}